// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-main-block[data-v-69f2b0d4] {
  position: relative;
  min-height: min-content;
  display: flex;
  flex-direction: column;
  padding: 30px 0;
}
.info-main-block .icon[data-v-69f2b0d4],
.info-main-block .info-block[data-v-69f2b0d4] {
  margin: auto;
}
.info-main-block .icon.clickable[data-v-69f2b0d4],
.info-main-block .info-block.clickable[data-v-69f2b0d4] {
  cursor: pointer;
}
.info-main-block .icon .contact-btns[data-v-69f2b0d4],
.info-main-block .info-block .contact-btns[data-v-69f2b0d4] {
  display: flex;
  margin-top: 30px;
}
.info-main-block .top-icons-block[data-v-69f2b0d4] {
  display: flex;
  position: absolute;
  top: 4px;
  right: 4px;
}
.info-main-block .top-icons-block .edit-btn[data-v-69f2b0d4] {
  display: flex;
  font-size: 16px;
  height: 35px;
  width: 35px;
  font-weight: 900;
  cursor: pointer;
}
.info-main-block .top-icons-block .edit-btn i[data-v-69f2b0d4] {
  font-size: 14px;
  margin: auto;
  color: var(--toolbtn-color);
}
.info-main-block .top-icons-block .edit-btn i[data-v-69f2b0d4]:hover {
  color: var(--toolbtn-color-hover);
}
.info-main-block .top-icons-block .fav-icon[data-v-69f2b0d4] {
  display: flex;
  height: 35px;
  width: 35px;
  font-size: 15px;
  font-weight: 900;
  cursor: pointer;
}
.info-main-block .top-icons-block .fav-icon i[data-v-69f2b0d4] {
  font-size: 16px;
  margin: auto;
  color: var(--toolbtn-color);
}
.info-main-block .top-icons-block .fav-icon i[data-v-69f2b0d4]:hover {
  color: var(--toolbtn-color-hover);
}
.info-main-block .info-block[data-v-69f2b0d4] {
  padding: 0 20px;
  width: 100%;
}
.info-main-block .common-text[data-v-69f2b0d4] {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1em;
}
.info-main-block .common-text .text-wrapper[data-v-69f2b0d4] {
  position: relative;
  max-width: 90%;
  padding: 0 6px;
  display: flex;
}
.info-main-block .common-text .text-wrapper .text[data-v-69f2b0d4] {
  text-align: center;
  font-size: 18px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: text;
}
.info-main-block .common-text .text-wrapper .official[data-v-69f2b0d4] {
  position: absolute;
  top: 50%;
  right: 0;
  height: 14px;
  width: 14px;
  border-radius: 8px;
  background-color: var(--icon-bgcolor2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 10px;
  transform: translate(100%, -50%);
}
.info-main-block .common-text i[data-v-69f2b0d4] {
  font-size: larger;
}
.info-main-block .additional-text[data-v-69f2b0d4] {
  color: var(--message-grey-color);
  text-align: center;
}
.info-main-block .additional-text p[data-v-69f2b0d4] {
  margin-bottom: 0;
  height: 20px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/InfoMainBlock.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".info-main-block[data-v-69f2b0d4] {\n  position: relative;\n  min-height: min-content;\n  display: flex;\n  flex-direction: column;\n  padding: 30px 0;\n}\n.info-main-block .icon[data-v-69f2b0d4],\n.info-main-block .info-block[data-v-69f2b0d4] {\n  margin: auto;\n}\n.info-main-block .icon.clickable[data-v-69f2b0d4],\n.info-main-block .info-block.clickable[data-v-69f2b0d4] {\n  cursor: pointer;\n}\n.info-main-block .icon .contact-btns[data-v-69f2b0d4],\n.info-main-block .info-block .contact-btns[data-v-69f2b0d4] {\n  display: flex;\n  margin-top: 30px;\n}\n.info-main-block .top-icons-block[data-v-69f2b0d4] {\n  display: flex;\n  position: absolute;\n  top: 4px;\n  right: 4px;\n}\n.info-main-block .top-icons-block .edit-btn[data-v-69f2b0d4] {\n  display: flex;\n  font-size: 16px;\n  height: 35px;\n  width: 35px;\n  font-weight: 900;\n  cursor: pointer;\n}\n.info-main-block .top-icons-block .edit-btn i[data-v-69f2b0d4] {\n  font-size: 14px;\n  margin: auto;\n  color: var(--toolbtn-color);\n}\n.info-main-block .top-icons-block .edit-btn i[data-v-69f2b0d4]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.info-main-block .top-icons-block .fav-icon[data-v-69f2b0d4] {\n  display: flex;\n  height: 35px;\n  width: 35px;\n  font-size: 15px;\n  font-weight: 900;\n  cursor: pointer;\n}\n.info-main-block .top-icons-block .fav-icon i[data-v-69f2b0d4] {\n  font-size: 16px;\n  margin: auto;\n  color: var(--toolbtn-color);\n}\n.info-main-block .top-icons-block .fav-icon i[data-v-69f2b0d4]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.info-main-block .info-block[data-v-69f2b0d4] {\n  padding: 0 20px;\n  width: 100%;\n}\n.info-main-block .common-text[data-v-69f2b0d4] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1em;\n}\n.info-main-block .common-text .text-wrapper[data-v-69f2b0d4] {\n  position: relative;\n  max-width: 90%;\n  padding: 0 6px;\n  display: flex;\n}\n.info-main-block .common-text .text-wrapper .text[data-v-69f2b0d4] {\n  text-align: center;\n  font-size: 18px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  user-select: text;\n}\n.info-main-block .common-text .text-wrapper .official[data-v-69f2b0d4] {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  height: 14px;\n  width: 14px;\n  border-radius: 8px;\n  background-color: var(--icon-bgcolor2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  font-size: 10px;\n  transform: translate(100%, -50%);\n}\n.info-main-block .common-text i[data-v-69f2b0d4] {\n  font-size: larger;\n}\n.info-main-block .additional-text[data-v-69f2b0d4] {\n  color: var(--message-grey-color);\n  text-align: center;\n}\n.info-main-block .additional-text p[data-v-69f2b0d4] {\n  margin-bottom: 0;\n  height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
